import React from 'react';
import cn from 'classnames';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { TypographyTextColorVariant } from 'apps/sigma2-ui/src/components/ui/Typography';
import { TypographyVariant } from 'apps/sigma2-ui/src/components/ui/Typography';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';

export const PageHeaderBadge: React.FC<{
  translatedContent?: TranslatedContent;
  label?: TranslatedContent;
  value?: TranslatedContent;
  className?: string;
  textClassName?: string;
  textColorVariant?: TypographyTextColorVariant;
  variant?: TypographyVariant;
  labelVariant?: TypographyVariant;
  valueVariant?: TypographyVariant;
}> = ({
  translatedContent,
  label,
  value,
  className,
  textClassName,
  textColorVariant = 'gray-700',
  variant = 'body-7',
  labelVariant = 'body-7-medium',
  valueVariant = 'body-7',
}) => {
  const shouldRenderSplitContent = label !== undefined && value !== undefined;

  return (
    <div className={cn('py-2 px-4 bg-indigo-100 rounded-lg', className)}>
      {shouldRenderSplitContent ? (
        <div className="flex items-center gap-3 whitespace-nowrap">
          <S2Typography
            as="span"
            variant={labelVariant}
            textColorVariant={textColorVariant}
            translatedContent={label}
            dangerouslyOverrideClassNameFn={(cn) =>
              cn + (textClassName ? ` ${textClassName}` : '')
            }
          />
          <S2Typography
            as="span"
            variant={valueVariant}
            textColorVariant={textColorVariant}
            translatedContent={value}
            dangerouslyOverrideClassNameFn={(cn) =>
              cn + (textClassName ? ` ${textClassName}` : '')
            }
          />
        </div>
      ) : (
        <S2Typography
          variant={variant}
          textColorVariant={textColorVariant}
          translatedContent={translatedContent ?? ''}
          dangerouslyOverrideClassNameFn={(cn) =>
            cn + (textClassName ? ` ${textClassName}` : '')
          }
        />
      )}
    </div>
  );
};
